import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 120px;
  .n {
    font-family: var(--font-sans);
    font-weight: 500;
    color: var(--ink);
    white-space: nowrap;
  }
  .n small {
    font-weight: 400;
    color: var(--text-muted);
  }
  .bar {
    width: 72px;
    height: 6px;
    border-radius: 999px;
    background: #f1f3f4;
    overflow: hidden;
    flex-shrink: 0;
  }
  .bar > span {
    display: block;
    height: 100%;
    border-radius: 999px;
  }
`;

/** Cor da barra igual à prancheta: 8+ ranqueadas verde, 1–7 amarelo, zero vermelho. */
const corDasPalavras = (ranked: number) =>
  ranked >= 8 ? "#1E8E3E" : ranked > 0 ? "#F9AB00" : "#D93025";

type Props = {
  ranked: number;
  total?: number;
};

/** "Palavras ranqueadas" com barra de progresso (a barra é relativa a 12, como no desenho). */
export const KeywordBarCell: React.FC<Props> = ({ ranked, total }) => {
  const pct = Math.min(100, (ranked / 12) * 100);
  return (
    <Wrap title={total != null ? `${ranked} ranqueadas de ${total} palavras` : `${ranked} ranqueadas`}>
      <span className="n">
        {ranked}
        {total != null && <small> / {total}</small>}
      </span>
      <span className="bar" aria-hidden="true">
        <span style={{ width: `${pct}%`, background: corDasPalavras(ranked) }} />
      </span>
    </Wrap>
  );
};
